import { Money } from "../../../common/models/CommonModels";
import { country } from "../../../shared/models/countryModels";
import { DayOfWeek, ShippingOptionCode, ShippingRegionCode } from "../../../shared/models/models";

export interface CustomerShippingOptionsState {
  shippingOptions?: ShippingOption;
  loading: boolean;
  success?: string;
  error: any;
}

export interface ShippingOption {
  warehouse: Warehouse;
  countryId: number;
  options: ShippingRegionOption[];
}

export interface Warehouse {
  address: string;
  opensAt: string;
  closesAt: string;
  daysOfWeek: DayOfWeek[];
}

export interface ShippingRegionOption {
  typeCode: ShippingOptionCode;
  regionCode: ShippingRegionCode;
  fromBusinessDays: number;
  toBusinessDays: number;
  orderPrice?: Money;
  isActive: boolean;
}

export interface ChangeShippingOptions {
  standartShippingOption: ShippingOptionType;
  expressShippingOption: ShippingOptionType;
  isSelfPickUpActive: boolean;
}

export interface ShippingOptionType {
  country: ShippingOptionInfo;
  europeanUnion: ShippingOptionInfo;
  worldwide: ShippingOptionInfo;
}

export interface ShippingOptionInfo {
  fromBusinessDays: number;
  toBusinessDays: number;
  orderPrice: Money;
  isActive: boolean;
}

export const regionName = (regionCode: number, countryId: number) => {
  switch (regionCode) {
    case ShippingRegionCode.country:
      return `Within ${country(countryId)?.name}`;
    case ShippingRegionCode.EU:
      return "Within EU";
    case ShippingRegionCode.worldwide:
      return "Worldwide";
  }
};

export const formControlRegionName = (regionCode: ShippingRegionCode) => {
  switch (regionCode) {
    case ShippingRegionCode.country:
      return "country" as const;
    case ShippingRegionCode.EU:
      return "europeanUnion" as const;
    default:
      return "worldwide" as const;
  }
};

export const formControlShippingOptionName = (typeCode: ShippingOptionCode) => {
  switch (typeCode) {
    case ShippingOptionCode.standart:
      return "standartShippingOption" as const;
    default:
      return "expressShippingOption" as const;
  }
};